import { Injectable, signal, Signal } from "@angular/core";
import GeobusNavigationExtension from "./geobus-navigation.extension";
import { IType } from "@geolib/geoappbase-client";


@Injectable({ providedIn: "root" })
export default class GeobusTrackingExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusTrackingExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.GENERAL.TRACKINGS").asReadonly();
    }

    public get category(): string {
        return "general";
    }

    public get state(): { name: string } {
        return { name: "app.trackings" };
    }

    public get icon(): string {
        return "object-list";
    }

}
